import {OS} from '@github-ui/get-os'
import type {GenericAsset} from '../../../../../brand/lib/types/contentful'

// Matches Primer Brand's `isLarge` breakpoint.
export const DESKTOP_MEDIA_QUERY = '(min-width: 1012px)'

export type SlideMedia = {
  /** Shown by default, and on small screens. */
  fallback: GenericAsset
  /** Shown instead of `fallback` when `DESKTOP_MEDIA_QUERY` matches. */
  desktop?: GenericAsset
}

const hasFile = (item: GenericAsset) => Boolean(item.fields.asset.fields.file)

/**
 * Picks the slide's assets by their Contentful `id`:
 *
 * - `macosMobile`    -> iOS, and macOS by default
 * - `macosDesktop`   -> macOS on large screens
 * - `windowsDesktop` -> any other OS on large screens
 * - `windowsMobile`  -> default
 *
 * The screen size is left to the browser (media queries). Only the OS needs JS.
 * Slides without a `windowsMobile` entry use their first asset.
 */
export function pickSlideMedia(media: readonly GenericAsset[] | undefined, os: OS): SlideMedia | undefined {
  const byId = (id: string) => media?.find(item => item.fields.id === id && hasFile(item))
  const windowsMobile = byId('windowsMobile')

  if (!windowsMobile) {
    const first = media?.find(hasFile)
    return first ? {fallback: first} : undefined
  }

  if (os === OS.iOS) return {fallback: byId('macosMobile') ?? windowsMobile}

  if (os === OS.macOS) {
    return {fallback: byId('macosMobile') ?? windowsMobile, desktop: byId('macosDesktop') ?? byId('windowsDesktop')}
  }

  return {fallback: windowsMobile, desktop: byId('windowsDesktop')}
}
